"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CompoundButton: function() {
        return _index.CompoundButton;
    },
    compoundButtonClassNames: function() {
        return _index.compoundButtonClassNames;
    },
    renderCompoundButton_unstable: function() {
        return _index.renderCompoundButton_unstable;
    },
    useCompoundButtonStyles_unstable: function() {
        return _index.useCompoundButtonStyles_unstable;
    },
    useCompoundButton_unstable: function() {
        return _index.useCompoundButton_unstable;
    }
});
const _index = require("./components/CompoundButton/index");
